import { useState, useEffect } from 'react';
import axios from 'axios';
import { ChevronRight } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const NewsTicker = ({ onArticleClick }) => {
  const [news, setNews] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    fetchNews();
    const interval = setInterval(fetchNews, 300000); // Refresh every 5 minutes
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (news.length > 0) {
      const ticker = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % news.length);
      }, 8000); // Change article every 8 seconds
      return () => clearInterval(ticker);
    }
  }, [news]);

  const fetchNews = async () => {
    try {
      console.log('🎯 Ticker fetching news from:', `${API}/api/crypto-news`);
      const response = await axios.get(`${API}/api/crypto-news?limit=5`);
      console.log('🎯 Ticker got articles:', response.data?.articles?.length);
      setNews(response.data.articles || []);
    } catch (error) {
      console.error('❌ Ticker error:', error);
    }
  };

  const getTimeAgo = (publishedAt) => {
    try {
      const date = new Date(publishedAt);
      const now = new Date();
      const seconds = Math.floor((now - date) / 1000);
      
      if (seconds < 60) return 'Just now';
      if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
      if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
      return `${Math.floor(seconds / 86400)}d ago`;
    } catch {
      return '';
    }
  };

  if (news.length === 0) return null;

  const currentArticle = news[currentIndex];

  return (
    <div 
      className="w-full bg-gradient-to-r from-[#FF0055]/10 via-[#FFD600]/10 to-[#00FF94]/10 border-b border-white/10 py-2 px-4 cursor-pointer hover:bg-white/5 transition-all"
      onClick={() => onArticleClick && onArticleClick()}
    >
      <div className="flex items-center gap-3 max-w-7xl mx-auto">
        <span className="flex-shrink-0 px-2 py-1 bg-[#FF0055] text-white text-xs font-bold rounded uppercase animate-pulse">
          🔴 Live
        </span>
        <div className="flex-1 flex items-center gap-2 overflow-hidden">
          <span className="text-sm font-semibold text-white truncate">
            {currentArticle.title}
          </span>
          <span className="text-xs text-muted-foreground flex-shrink-0">
            • {getTimeAgo(currentArticle.published_at)}
          </span>
        </div>
        <ChevronRight className="w-4 h-4 text-muted-foreground flex-shrink-0" />
      </div>
    </div>
  );
};

export default NewsTicker;